import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useQuery } from 'react-apollo';

import ImportIcon from '../../../../../components/icons/ImportIcon';
import Angle from '../../../../../components/global/Angle';
import getCardAddressImportUrlQuery from '../../../graphql/queries/getCardAddressImportUrl';
import { isMobile } from '../../../../../util/device-detector';
import Button from '../../../../../components/global/Button';
import useIsNativeWebView from '../../../../native-bridge/hooks/useIsWebView';
import { postNativeEmailClientRequest } from '../../../../native-bridge/native-apps-interface';

const propTypes = {
  className: PropTypes.string,
  onImport: PropTypes.func.isRequired,
  accountCard: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }).isRequired,
};

const AddressListItemImportButton = ({ className, onImport, accountCard }) => {
  const classes = classNames({
    'address-list-action-button': true,
    'address-list-item-import-button': true,
    [className]: !!className,
  });

  const isNativeWebView = useIsNativeWebView();

  const { data: { me: account, loading } = {} } = useQuery(
    getCardAddressImportUrlQuery,
    {
      variables: {
        account_card_id: accountCard?.id,
      },
      skip: !accountCard || !isMobile(),
    },
  );

  const url = account?.web_app_urls?.card_address_import_url;

  if (loading) {
    return null;
  }

  const importFromDesktop = !!url && isMobile();
  const email = account?.email_address || '';
  const subject = 'Waldo contact spreadsheet import url';
  const body = `You can follow the link below on your computer to import your
   contacts via a spreadsheet or CSV file.

   ${url}
  `;

  const onClick = () => {
    if (!importFromDesktop) {
      onImport();
      return;
    }

    if (isNativeWebView) {
      postNativeEmailClientRequest({
        email_address: email,
        subject,
        body,
      });
    }
  };

  return (
    <Button
      btnStyle="reset"
      href={
        importFromDesktop
          ? `mailto:${email}?subject=${subject}&body=${body}`
          : undefined
      }
      className={classes}
      onClick={onClick}
    >
      <ImportIcon /> Import from spreadsheet or CSV
      <Angle direction="right" />
    </Button>
  );
};

AddressListItemImportButton.propTypes = propTypes;

export default AddressListItemImportButton;
